// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9bd36dca","732":"b2edf555","977":"31f3e2fd"}[chunkId] + ".chunk.js";
};